/*
 * @Author: Ryan
 * @Date: 2026-01-30
 * @Description: Cookie 工具函数（独立文件，避免打包 crypto polyfill）
 */
import cookie from 'js-cookie';

import { COOKIE_DOMAIN } from '@/config';

// 获取cookie信息
export const getCookie = (str: string) => JSON.parse(cookie.get(str) || '{}');

/**
 * 设置cookie信息
 * @param key
 * @param value
 * @param time 天
 */
export const setCookie = (key: string, value: string | number, time = 7) => {
  const expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + time);
  cookie.set(key, JSON.stringify(value), {
    expires: expirationDate,
    domain: COOKIE_DOMAIN,
  });
};

export const removeCookie = (key: string) => {
  cookie.remove(key, {
    domain: COOKIE_DOMAIN,
  });

  cookie.remove(key);
};
